import { styles } from '../globals/map-styles';

const google = window.google;
let map;

export default {
  init() {
    const $cylchMap = $('#cylch-map');
    const mapLat = parseFloat($cylchMap.data('lat'));
    const mapLong = parseFloat($cylchMap.data('long'));
    const mapEl = $cylchMap.get()[0];

    function initMap() {
      map = new google.maps.Map(mapEl, {
        center: {
          lat: mapLat,
          lng: mapLong,
        },
        styles: styles,
        zoom: 12,
      });

      // marker pin image
      const pin_image = {
        url: '/wp-content/themes/meithrin/resources/assets/images/Icons_Pin.svg',
        scaledSize: new google.maps.Size(33, 47),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 47),
      }

      // Get nearby schools (if any)
      const nearbySchools = $cylchMap.data('nearby-schools');

      if (nearbySchools && nearbySchools.length > 0) {
        if (nearbySchools.length > 0) {
          var marker_list = [];

          const lang_address = 'Address';
          const lang_phone = 'Phone Number';

          nearbySchools.forEach((school) => {
            

            const contentString = `
              <div class="cylch-map-content">
                <span class="content-title">${school.name}</span>
                <div class="body-content">
                  <p><strong>${lang_address}:</strong> ${school.address}</p>
                  <p><strong>${lang_phone}:</strong> ${school.phone_number}</p>
                </div>
              </div>`;

            const infoWindow = new google.maps.InfoWindow({
              content: contentString,
            });

            const marker = new google.maps.Marker({
              position: {
                lat: parseFloat(school.lat),
                lng: parseFloat(school.lng),
              },
              map: map,
              title: school.name,
            });

            marker.addListener('click', () => {
              // close other marker info windows
              marker_list.forEach((the_marker) => {
                the_marker[1].close();
              });

              infoWindow.open(map, marker);
            });

            marker_list.push([marker, infoWindow]);

          });
        }
      }

      // Cylch marker
      new google.maps.Marker({
        position: {
          lat: mapLat,
          lng: mapLong,
        },
        map: map,
        icon: pin_image,
      });
    }

    $(document).ready(function () {
      initMap();
    });
  },
  finalize() {

  },
}



// WEBPACK FOOTER //
// ./scripts/routes/single-cylchs.js